export const decodeHTML = (input: string): string => {
	const target = document.createElement('div');
	target.innerHTML = input;

	return target.textContent || target.innerText || '';
};
